import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

const ContentCard = ({ 
    children, 
    type = 'default', // 'question' | 'answer' | 'default'
    style = {} 
}) => {
    const getStyle = () => {
        switch (type) {
            case 'question':
                return {
                    padding: '0',
                    borderRadius: 4,
                    backgroundColor: '#e6f7ff',
                    border: '1px solid #91caff'
                };
            case 'answer':
                return {
                    padding: '0',
                    borderRadius: 4,
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #d9d9d9'
                };
            default:
                return {
                    padding: '0',
                    borderRadius: 4,
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #d9d9d9'
                };
        }
    };

    return (
        <Card 
            style={{
                ...getStyle(),
                ...style
            }}
            styles={{ body: { padding: '12px' } }}
            bordered={false}
        >
            {children}
        </Card>
    );
};

export default ContentCard; 